module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero@1x.ef890d1.png";